// components
import { SettingsComponent } from './settings.component';
import { EmailSettingsComponent } from './email/email.settings.component';
import { PhoneSettingsComponent } from './phone/phone.settings.component';
import { DateSettingsComponent } from './date/date.settings.component';

export const SETTINGS_COMPONENTS: any[] = [
  SettingsComponent,
  EmailSettingsComponent,
  PhoneSettingsComponent,
  DateSettingsComponent,
];

// services



// WEBPACK FOOTER //
// ./src/app/components/dashboard/settings/index.ts